import { render, staticRenderFns } from "./Profilesettings.vue?vue&type=template&id=0ca392be&scoped=true"
import script from "./Profilesettings.vue?vue&type=script&lang=js"
export * from "./Profilesettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca392be",
  null
  
)

export default component.exports